import React, { useState } from 'react';
import { 
  Box, 
  List, 
  ListItem, 
  ListItemAvatar, 
  ListItemText, 
  Avatar, 
  Divider, 
  IconButton, 
  InputBase, 
  Typography, 
  Menu, 
  MenuItem 
} from '@mui/material';
import { 
  Send, 
  MoreVert, 
  Group, 
  Person, 
  GroupAdd, 
  ExitToApp 
} from '@mui/icons-material';

const Chat = () => {
  const [selectedChat, setSelectedChat] = useState(null);
  const [newMessage, setNewMessage] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [messages, setMessages] = useState([
    { id: 1, sender: 'John', text: 'Hey there!', timestamp: '10:30 AM' },
    { id: 2, sender: 'You', text: 'Hi John!', timestamp: '10:31 AM' },
  ]);

  // Mock chat list data
  const chats = [
    { id: 1, name: 'Design Team', type: 'group', members: 5, lastMessage: 'Let me check the mockups...' },
    { id: 2, name: 'Manager', type: 'personal', lastMessage: 'Thanks for the update!' },
  ];

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      setMessages([...messages, {
        id: messages.length + 1,
        sender: 'You',
        text: newMessage,
        timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      }]);
      setNewMessage('');
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAddToGroup = () => {
    // Add to group logic
    handleMenuClose();
  };

  const handleLeaveGroup = () => {
    // Leave group logic
    handleMenuClose();
  };

  return (
    <Box display="flex" height="calc(100vh - 64px)">

      {/* Chat List Sidebar */}
      {/*
        // TODO: update latest message when new message received
        // TODO: organize chats based on most recent message
        // TODO: show unread messages count
        // TODO: 
      */}
      <Box width={300} borderRight="1px solid #e0e0e0">
        <List>
          {chats.map(chat => (
            <ListItem 
              button 
              key={chat.id}
              onClick={() => setSelectedChat(chat)}
              sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: chat.type === 'group' ? '#1976d2' : '#4caf50' }}>
                  {chat.type === 'group' ? <Group /> : <Person />}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={chat.name}
                secondary={chat.lastMessage}
                secondaryTypographyProps={{ noWrap: true }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Chat Area */}
      <Box flex={1} display="flex" flexDirection="column">
        {/* Chat Header */}
        <Box display="flex" alignItems="center" p={2} borderBottom="1px solid #e0e0e0">
          {selectedChat && (
            <>
              <Avatar sx={{ bgcolor: selectedChat.type === 'group' ? '#1976d2' : '#4caf50' }}>
                {selectedChat.type === 'group' ? <Group /> : <Person />}
              </Avatar>
              <Box ml={2} flex={1}>
                <Typography variant="h6">{selectedChat.name}</Typography>
                {selectedChat.type === 'group' && (
                  <Typography variant="caption">{selectedChat.members} members</Typography>
                )}
              </Box>
              <IconButton onClick={handleMenuOpen}>
                <MoreVert />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {selectedChat?.type === 'group' ? (
                  <>
                    <MenuItem onClick={handleAddToGroup}>
                      <GroupAdd sx={{ mr: 1 }} /> Add People
                    </MenuItem>
                    <MenuItem onClick={handleLeaveGroup}>
                      <ExitToApp sx={{ mr: 1 }} /> Leave Group
                    </MenuItem>
                  </>
                ) : (
                  <MenuItem onClick={handleAddToGroup}>
                    <GroupAdd sx={{ mr: 1 }} /> Start Group Chat
                  </MenuItem>
                )}
              </Menu>
            </>
          )}
        </Box>

        {/*
          // TODO: focus on the last message when chat is opened
        */}

        {/* Messages Area */}
        <Box flex={1} p={2} overflow="auto">
          {messages.map(message => (
            <Box 
              key={message.id}
              mb={2}
              alignSelf={message.sender === 'You' ? 'flex-end' : 'flex-start'}
              maxWidth="70%"
            >
              <Typography variant="caption" color="textSecondary">
                {message.sender}
              </Typography>
              <Box 
                bgcolor={message.sender === 'You' ? '#1976d2' : '#e0e0e0'}
                color={message.sender === 'You' ? 'white' : 'black'}
                p={1.5}
                borderRadius={2}
              >
                <Typography>{message.text}</Typography>
                <Typography variant="caption" display="block" textAlign="right">
                  {message.timestamp}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Message Input */}
        <Box p={2} borderTop="1px solid #e0e0e0">
          <Box display="flex" alignItems="center">
            <InputBase
              fullWidth
              placeholder="Type a message"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
              sx={{ mr: 1 }}
            />
            <IconButton 
              onClick={handleSendMessage}
              disabled={!newMessage.trim()}
              color="primary"
            >
              <Send />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Chat;